import React, { useEffect } from 'react';
import useAccessibleDialog from '../../hooks/useAccessibleDialog';

export default function DistributorCustomerDialog({
  customer,
  open,
  locked,
  onClose,
  error,
  notice,
  onRetry,
  children,
  t,
}) {
  const { dialogRef, titleId } = useAccessibleDialog({ open, onClose, closeDisabled: locked });
  useEffect(() => {
    if (!open) return undefined;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [open]);
  return (
    <div
      hidden={!open}
      className="me-dw-section me-dw-customer-overlay !m-0 fixed inset-0 flex items-center justify-center bg-black/40 p-3 sm:p-5"
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        className="me-dw-card me-dw-customer-dialog flex w-full max-w-5xl flex-col overflow-hidden"
      >
        <div className="flex shrink-0 items-start justify-between gap-4 border-b border-[#e1ebeb] px-5 py-4 sm:px-6">
          <div className="min-w-0">
            <p className="mb-1 text-xs font-semibold text-[#5e737a]">{t('Customer details')}</p>
            <h2 id={titleId} className="break-words text-xl font-bold text-[#153d48]">
              {customer.name}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={locked}
            className="me-dw-link me-dw-customer-close shrink-0 text-sm disabled:opacity-50"
          >
            {t('Close')}
          </button>
        </div>
        <div className="me-dw-customer-body">
          {error && (
            <p role="alert" className="mb-4 text-sm text-red-700">
              {t(error)}{' '}
              {onRetry && (
                <button type="button" className="underline" onClick={onRetry}>
                  {t('Retry')}
                </button>
              )}
            </p>
          )}
          {notice && (
            <p role="status" className="mb-4 text-sm text-green-700">
              {t(notice)}
            </p>
          )}
          {children}
        </div>
        {locked && (
          <p
            role="status"
            className="shrink-0 border-t border-[#e1ebeb] px-5 py-3 text-sm text-[#5e737a]"
          >
            {t('Save or discard your changes before closing.')}
          </p>
        )}
      </div>
    </div>
  );
}
